<template>
  <BaseModal
    :value="dialogState"
    :modal-title="$t('folder.workflow.deletStatusConfirmation')"
    @click:outside="close"
    @keydown.esc="close"
    @close="close"
  >
    <template #modal>
      <div class="text-center">
        <BaseParagraph v-text="$t('folder.workflow.deletStatusConfirmation')" />
      </div>
    </template>
    <template #actions>
      <BaseButton
        text
        class="mx-2 ml-auto"
        type="secondary"
        color="#707080"
        @click="close"
      >
        {{ $t("utils.cancel") }}
      </BaseButton>
      <BaseButton color="secondary" type="primary" @click="submit">
        {{ $t("utils.delete") }}
      </BaseButton>
    </template>
  </BaseModal>
</template>

<script>
import { deleteOrganizationWorkflowStatus } from "@/modules/Admin/Services/workflow.service";
export default {
  name: "WorkflowDeleteStatusDialog",
  props: {
    dialogState: {
      type: Boolean,
    },
    activeStatus: {
      type: Object,
      default: () => null,
    },
  },
  methods: {
    close() {
      this.$emit("close");
    },
    async submit() {
      try {
        await deleteOrganizationWorkflowStatus(
          this.$route.params.organizationId,
          this.$route.params.workflowId,
          this.activeStatus.id
        );
        this.$emit("statusDeleted", this.activeStatus);
        this.$store.dispatch("snackbar/active", {
          message: this.$t(
            "workflow.status.snackbar.success.statusDeletedSuccessfully"
          ),
          type: "SUCCESS",
        });
      } catch {
        this.$store.dispatch("snackbar/active", {
          message: this.$t(
            "workflow.status.snackbar.error.errorDeletingStatus"
          ),
          type: "ERROR",
        });
      }
    },
  },
};
</script>
